/**
 * TempoSupply – Newsletter Double-Opt-In Hinweis-Popup
 * Öffnet sich nach erfolgreicher Newsletter-Anmeldung statt der Toast-Meldung.
 */
(function () {
  'use strict';

  var popup = null;
  var lastFocus = null;
  var OPEN_CLASS = 'ts-nl-doi-open';

  function getPopup() {
    if (!popup) {
      popup = document.getElementById('ts-newsletter-doi-popup');
    }
    return popup;
  }

  function stopNewsletterAnchorScroll() {
    if ('scrollRestoration' in history) {
      try { history.scrollRestoration = 'manual'; } catch (e) {}
    }

    var url = new URL(window.location.href);
    var hasNewsletterHash = url.hash && /newsletter/i.test(url.hash);
    var hasPosted = url.searchParams.get('customer_posted') === 'true';

    if (hasNewsletterHash || hasPosted) {
      if (hasNewsletterHash) {
        url.hash = '';
      }
      try {
        history.replaceState(null, '', url.pathname + url.search + url.hash);
      } catch (e) {}
    }

    window.scrollTo(0, 0);
    if (document.documentElement) {
      document.documentElement.scrollTop = 0;
    }
    if (document.body) {
      document.body.scrollTop = 0;
    }
  }

  function openPopup() {
    var el = getPopup();
    if (!el) { return; }

    stopNewsletterAnchorScroll();

    lastFocus = document.activeElement;
    el.hidden = false;
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add(OPEN_CLASS);

    // CTA fokussieren (nicht Backdrop), damit kein Scroll-Jump entsteht
    var cta = el.querySelector('.ts-nl-doi__cta');
    if (cta && typeof cta.focus === 'function') {
      setTimeout(function () {
        stopNewsletterAnchorScroll();
        cta.focus({ preventScroll: true });
      }, 40);
    }

    // Nochmal nach Hash-Scroll des Browsers
    setTimeout(stopNewsletterAnchorScroll, 0);
    setTimeout(stopNewsletterAnchorScroll, 120);
  }

  function closePopup() {
    var el = getPopup();
    if (!el) { return; }
    el.hidden = true;
    el.setAttribute('aria-hidden', 'true');
    document.body.classList.remove(OPEN_CLASS);
    if (lastFocus && typeof lastFocus.focus === 'function') {
      try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
    }
  }

  function onDocClick(e) {
    var t = e.target;
    if (!t) { return; }
    if (t.closest && t.closest('[data-ts-nl-doi-close]')) {
      e.preventDefault();
      closePopup();
    }
  }

  function onKeydown(e) {
    if (e.key === 'Escape' && getPopup() && !getPopup().hidden) {
      closePopup();
    }
  }

  function removeNewsletterSuccessToasts() {
    var list = document.querySelector('.l4al.fixed');
    if (!list) { return; }
    Array.from(list.querySelectorAll('.message-newsletter.overlay-lime')).forEach(function (li) {
      li.remove();
    });
  }

  function shouldOpenFromUrl() {
    return new URLSearchParams(window.location.search).get('customer_posted') === 'true';
  }

  function init() {
    var el = getPopup();
    if (!el) { return; }

    document.addEventListener('click', onDocClick);
    document.addEventListener('keydown', onKeydown);

    window.tsNewsletterDoiPopup = {
      open: openPopup,
      close: closePopup
    };

    if (document.querySelector('.l4al .message-newsletter.overlay-lime') || shouldOpenFromUrl()) {
      removeNewsletterSuccessToasts();
      // Sofort gegen Hash-Scroll, bevor Layout springt
      stopNewsletterAnchorScroll();
      openPopup();
    }
  }

  // Möglichst früh gegen Hash-Scroll (vor DOMContentLoaded)
  if (shouldOpenFromUrl()) {
    if ('scrollRestoration' in history) {
      try { history.scrollRestoration = 'manual'; } catch (e) {}
    }
    stopNewsletterAnchorScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('showAlert', function (event) {
    var detail = event && event.detail ? event.detail : {};
    if (detail.origin === 'newsletter' && detail.type === 'success') {
      setTimeout(function () {
        removeNewsletterSuccessToasts();
        openPopup();
      }, 0);
    }
  });
})();
